import { renameKeysFromRESTResponseToSDKResponse } from '@wix/sdk-runtime/rename-all-nested-keys';
import { transformRESTTimestampToSDKTimestamp } from '@wix/sdk-runtime/transformations/timestamp';
import { transformPaths } from '@wix/sdk-runtime/transformations/transform-paths';
import { EventDefinition } from '@wix/sdk-types';
import { createExternalDatabaseConnection as universalCreateExternalDatabaseConnection, deleteExternalDatabaseConnection as universalDeleteExternalDatabaseConnection, getExternalDatabaseConnection as universalGetExternalDatabaseConnection, listExternalDatabaseConnections as universalListExternalDatabaseConnections, updateExternalDatabaseConnection as universalUpdateExternalDatabaseConnection, } from './data-v1-external-database-connection-external-database-connections.universal';
export const __metadata = { PACKAGE_NAME: '@wix/data' };
export function getExternalDatabaseConnection(httpClient) {
    return (name) => universalGetExternalDatabaseConnection(name, 
    // @ts-ignore
    { httpClient });
}
export function listExternalDatabaseConnections(httpClient) {
    return (options) => universalListExternalDatabaseConnections(options, 
    // @ts-ignore
    { httpClient });
}
export function createExternalDatabaseConnection(httpClient) {
    return (externalDatabaseConnection, options) => universalCreateExternalDatabaseConnection(externalDatabaseConnection, options, 
    // @ts-ignore
    { httpClient });
}
export function updateExternalDatabaseConnection(httpClient) {
    return (name, externalDatabaseConnection) => universalUpdateExternalDatabaseConnection(name, externalDatabaseConnection, 
    // @ts-ignore
    { httpClient });
}
export function deleteExternalDatabaseConnection(httpClient) {
    return (name) => universalDeleteExternalDatabaseConnection(name, 
    // @ts-ignore
    { httpClient });
}
export const onExternalDatabaseConnectionCreated = EventDefinition('wix.data.v1.external_database_connection_created', true, (event) => renameKeysFromRESTResponseToSDKResponse(transformPaths(event, [
    {
        transformFn: transformRESTTimestampToSDKTimestamp,
        paths: [{ path: 'metadata.eventTime' }],
    },
])))();
export const onExternalDatabaseConnectionUpdated = EventDefinition('wix.data.v1.external_database_connection_updated', true, (event) => renameKeysFromRESTResponseToSDKResponse(transformPaths(event, [
    {
        transformFn: transformRESTTimestampToSDKTimestamp,
        paths: [{ path: 'metadata.eventTime' }],
    },
])))();
export const onExternalDatabaseConnectionDeleted = EventDefinition('wix.data.v1.external_database_connection_deleted', true, (event) => renameKeysFromRESTResponseToSDKResponse(transformPaths(event, [
    {
        transformFn: transformRESTTimestampToSDKTimestamp,
        paths: [{ path: 'metadata.eventTime' }],
    },
])))();
export { CauseOfFailure, CollectionsFound, ConnectionType, FieldType, ProtocolVersion, WebhookIdentityType, } from './data-v1-external-database-connection-external-database-connections.universal';
//# sourceMappingURL=data-v1-external-database-connection-external-database-connections.public.js.map